"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var extractParamValues = function extractParamValues(param) {
  var anchorElements = document.getElementsByTagName('a');
  var anchors = Array.from(anchorElements);
  var values = anchors.map(function (_ref) {
    var href = _ref.href;
    return href;
  }).filter(function (href) {
    var url;
    try {
      url = new URL(href);
    } catch (error) {
      return false;
    }
    var _url = url,
      searchParams = _url.searchParams,
      origin = _url.origin;
    var params = Array.from(searchParams.keys());
    var hasParam = params.some(function (key) {
      return key.toLowerCase() === param.toLowerCase();
    });
    var isTelusUrl = origin.includes('telus');
    return hasParam && isTelusUrl;
  }).map(function (href) {
    var _URL = new URL(href),
      searchParams = _URL.searchParams;
    var params = Array.from(searchParams.keys());
    var searchedParam = params.find(function (key) {
      return key.toLowerCase() === param.toLowerCase();
    });
    return searchParams.get(searchedParam);
  });
  var uniqueValues = new Set(values);
  return Array.from(uniqueValues);
};
var _default = exports["default"] = extractParamValues;